import React from 'react';
import BackButton from '../components/BackButton';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';

const Contact = () => {
  // Inline styles for ultra-premium cinematic animations
  const premiumStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@200;300;400;500;600;700;800&display=swap');
    
    .font-premium {
      font-family: 'Outfit', sans-serif;
    }

    /* Ambient floating lighting */
    @keyframes blob {
      0% { transform: translate(0px, 0px) scale(1); }
      33% { transform: translate(30px, -50px) scale(1.1); }
      66% { transform: translate(-20px, 20px) scale(0.9); }
      100% { transform: translate(0px, 0px) scale(1); }
    }
    .animate-blob {
      animation: blob 10s infinite cubic-bezier(0.4, 0, 0.2, 1);
    }
    .animation-delay-2000 { animation-delay: 2s; }
    .animation-delay-4000 { animation-delay: 4s; }

    /* Hyper-realistic liquid glass (Dark Mode) */
    .liquid-glass {
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.01) 100%);
      backdrop-filter: blur(24px) saturate(180%);
      -webkit-backdrop-filter: blur(24px) saturate(180%);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-top: 1px solid rgba(255, 255, 255, 0.2);
      border-left: 1px solid rgba(255, 255, 255, 0.15);
      box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.1);
    }

    /* Interactive glass for cards */
    .liquid-glass-card {
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(15, 23, 42, 0.4) 100%);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      border: 1px solid rgba(255, 255, 255, 0.05);
      transition: all 0.5s cubic-bezier(0.25, 1, 0.5, 1);
    }
    .liquid-glass-card:hover {
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(15, 23, 42, 0.6) 100%);
      border: 1px solid rgba(34, 211, 238, 0.3);
      box-shadow: 0 20px 40px rgba(8, 145, 178, 0.2), inset 0 0 20px rgba(34, 211, 238, 0.05);
      transform: translateY(-8px);
    }
    
    /* Chrome/Liquid text gradient */
    .text-liquid-gradient {
      background: linear-gradient(to right, #ffffff 20%, #a5f3fc 40%, #ffffff 60%, #e0f2fe 80%);
      background-size: 200% auto;
      color: #000;
      background-clip: text;
      text-fill-color: transparent;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: shine 8s linear infinite;
    }
    
    @keyframes shine {
      to { background-position: 200% center; }
    }
  `;

  return (
    <div className="font-premium min-h-screen bg-[#020617] text-white selection:bg-cyan-500/30 selection:text-cyan-50 flex flex-col relative overflow-hidden">
      <style>{premiumStyles}</style>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/918138993705"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 bg-[#25D366] text-white p-4 rounded-full shadow-[0_10px_40px_rgba(37,211,102,0.5)] hover:scale-110 hover:-translate-y-3 transition-all duration-500 z-50 flex items-center justify-center group overflow-hidden border border-white/20 backdrop-blur-sm"
        aria-label="Contact Tank Care on WhatsApp"
      >
        <div className="absolute inset-0 bg-white/20 group-hover:scale-150 transition-transform duration-500 rounded-full opacity-0 group-hover:opacity-100"></div>
        <svg className="w-8 h-8 fill-current relative z-10" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
        </svg>
      </a>

      {/* Cinematic Background Elements */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[-10%] right-[10%] w-[600px] h-[600px] bg-cyan-900/30 rounded-full mix-blend-screen filter blur-[120px] animate-blob"></div>
        <div className="absolute bottom-[10%] left-[-10%] w-[500px] h-[500px] bg-blue-900/30 rounded-full mix-blend-screen filter blur-[120px] animate-blob animation-delay-4000"></div>
        {/* Subtle tech grid */}
        <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)', backgroundSize: '50px 50px' }}></div>
      </div>

      <main className="flex-grow w-full max-w-7xl mx-auto px-6 md:px-12 pb-24 pt-32 md:pt-40 relative z-10">
        
        <div className="mb-8">
          <BackButton />
        </div>

        <Reveal>
          <div className="max-w-4xl mx-auto">
            <header className="mb-12 md:mb-16 text-center">
              <div className="inline-flex items-center justify-center gap-3 px-6 py-2.5 rounded-full liquid-glass mb-6">
                <span className="material-symbols-outlined text-cyan-400 text-sm">support_agent</span>
                <span className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-50">Priority Support</span>
              </div>
              <h1 className="text-4xl sm:text-5xl md:text-7xl font-extrabold mb-4 md:mb-6 tracking-tighter">
                <span className="text-liquid-gradient">Contact Us</span>
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl text-cyan-50/70 font-light leading-relaxed max-w-2xl mx-auto">
                We're here to assist you with all your aquatic hygiene needs across the Calicut region.
              </p>
            </header>
            
            <div className="liquid-glass rounded-[2rem] md:rounded-[2.5rem] p-6 sm:p-8 md:p-14 shadow-[0_30px_80px_rgba(0,0,0,0.5)]">
              <section>
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-6 md:mb-8 flex items-center gap-4 border-b border-white/10 pb-4 md:pb-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl md:rounded-2xl bg-cyan-500/20 flex items-center justify-center border border-cyan-400/30 shrink-0">
                    <span className="material-symbols-outlined text-cyan-400">forum</span>
                  </div>
                  Get in Touch
                </h2>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                  {/* Email Card */}
                  <div className="liquid-glass-card p-6 md:p-8 rounded-2xl md:rounded-3xl flex flex-col gap-3 md:gap-4 group">
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-slate-800 flex items-center justify-center group-hover:bg-cyan-500/20 transition-colors duration-500 shrink-0">
                      <span className="material-symbols-outlined text-cyan-400 text-2xl md:text-3xl group-hover:scale-110 transition-transform duration-500">mail</span>
                    </div>
                    <span className="text-[10px] md:text-xs font-bold uppercase tracking-[0.2em] text-slate-400">Email Us</span>
                    {/* Fluid typography and break-all to prevent overflow on very small devices */}
                    <a href="mailto:support@tankcare.com" className="text-[clamp(1rem,4.5vw,1.5rem)] md:text-2xl font-semibold text-white hover:text-cyan-400 transition-colors duration-300 break-words sm:break-normal">
                      support@tankcare.com
                    </a>
                  </div>
                  
                  {/* Phone Card */}
                  <div className="liquid-glass-card p-6 md:p-8 rounded-2xl md:rounded-3xl flex flex-col gap-3 md:gap-4 group">
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-slate-800 flex items-center justify-center group-hover:bg-cyan-500/20 transition-colors duration-500 shrink-0">
                      <span className="material-symbols-outlined text-cyan-400 text-2xl md:text-3xl group-hover:scale-110 transition-transform duration-500">call</span>
                    </div>
                    <span className="text-[10px] md:text-xs font-bold uppercase tracking-[0.2em] text-slate-400">Call / WhatsApp</span>
                    <a href="tel:+918138993705" className="text-[clamp(1.1rem,4.5vw,1.5rem)] md:text-2xl font-semibold text-white hover:text-cyan-400 transition-colors duration-300 whitespace-nowrap">
                      +91 81389 93705
                    </a>
                  </div>
                  
                  {/* Location Card */}
                  {/* <div className="md:col-span-2 liquid-glass-card p-6 md:p-8 rounded-2xl md:rounded-3xl flex flex-col gap-3 md:gap-4 group">
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-slate-800 flex items-center justify-center group-hover:bg-cyan-500/20 transition-colors duration-500 shrink-0">
                      <span className="material-symbols-outlined text-cyan-400 text-2xl md:text-3xl group-hover:scale-110 transition-transform duration-500">location_on</span>
                    </div>
                    <span className="text-[10px] md:text-xs font-bold uppercase tracking-[0.2em] text-slate-400">Headquarters</span>
                    <p className="text-base sm:text-lg md:text-2xl font-light text-slate-200 leading-relaxed">
                      Tank Care HQ, Cyber Park Area<br/>
                      Calicut, Kerala 673016
                    </p>
                  </div> */}
                </div>
              </section>
            </div>
          </div>
        </Reveal>
      </main>
      
      {/* Footer */}
      <div className="relative z-10 border-t border-white/10 bg-[#020617]">
        <Footer />
      </div>
    </div>
  );
};

export default Contact;